<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12 class="text-xs-center" mt-5>
                <h1>{{this.$t('register_device_section_title')}}</h1>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3 mt-3>
                <form @submit.prevent="register">
                    <v-layout column>
                        <v-flex>
                            <v-text-field
                                    v-model="deviceName"
                                    :label="this.$t('device_name_input_label')"
                                    type="username"
                                    required>
                            </v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field
                                    v-model="name"
                                    :label="this.$t('name_input_label')"
                                    required>
                            </v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-switch v-model="private_subscription" :label="this.$t('private_subscription_input_label')"></v-switch>
                        </v-flex>
                        <v-flex>
                            <api-result-viewer :data="api_response"></api-result-viewer>
                        </v-flex>
                        <v-flex class="text-xs-center" mt-5>
                            <v-btn color="primary" type="submit" v-if="api_response !== 1">{{this.$t('register_btn_message')}}</v-btn>
                        </v-flex>
                    </v-layout>
                </form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import ApiResultViewer from '../components/api/APIResultViewer'
    export default {
        data() {
            return {
                deviceName: null,
                name : null,
                private_subscription: false,
                api_response : 0
            }
        },
        created(){
          window.$initFirebaseMessagingRegistration();
        },
        methods: {
            register: function () {
                this.api_response = 1;

                let data = {
                    device_name: this.deviceName,
                    name: this.name,
                    private_subscription: this.private_subscription
                }
                this.$store.dispatch('register', data)
                    .then(() => {
                        this.$router.push('/dashboard')
                        this.api_response = 0
                    })
                    .catch(error => {
                        this.validationErrors = error
                        this.api_response = error
                    })
            }
        },
        components:{
            ApiResultViewer
        }
    }
</script>

<i18n>
    {
        "en": {
            "register_device_section_title": "Register device",
            "device_name_input_label": "Device Name (unique identification name)",
            "name_input_label": "Name",
            "private_subscription_input_label": "Private subscription?",
            "register_btn_message": "Register!"
        },
        "es": {
            "register_device_section_title": "Registrar dispositivo",
            "device_name_input_label": "Nombre de Dispositivo (nombre único de identificación)",
            "name_input_label": "Nombre",
            "private_subscription_input_label": "Subscripción privada?",
            "register_btn_message": "Registrar!"
        }
    }
</i18n>